import { render, staticRenderFns } from "./AllBookings.vue?vue&type=template&id=c8852f10&scoped=true"
import script from "./AllBookings.vue?vue&type=script&lang=js"
export * from "./AllBookings.vue?vue&type=script&lang=js"
import style0 from "./AllBookings.vue?vue&type=style&index=0&id=c8852f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8852f10",
  null
  
)

export default component.exports